import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { AddressModel } from '../../address/address.model';

import { ConfigurationSettings } from "../.././configuration-settings"

@Injectable()
export class AddressService {

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(private _http: HttpClient) { }

  public createAddress(address: AddressModel, email: string): any {
    let url = ConfigurationSettings.REST_API_URL + "/api/Address/recipients/" + email + "/addresses"
    let body = JSON.stringify(address);

    return this._http.post(
      url,
      body, this.httpOptions).pipe(
        tap(x => console.log("Created new Address"))
      );
  }

  public getAddresss(): any {
    let url = ConfigurationSettings.REST_API_URL + "/api/addresss"
    return this._http.get(url).pipe(
      tap(x => console.log("Fetched Addresss")));
  }

  public ValidateAddressLine1(address: AddressModel): any {
    // Use the parameter names that work in Swagger: AddressLine1, City, State, PostalCode
    let url = ConfigurationSettings.REST_API_URL + "/api/Address/ValidateUSPSAddress?AddressLine1="+encodeURIComponent(address.AddressLine1)+"&City="+encodeURIComponent(address.City)+"&State="+encodeURIComponent(address.State)+"&PostalCode="+encodeURIComponent(address.PostalCode); 
    console.log('VALIDATION REQUEST URL:', url);
    console.log('VALIDATION REQUEST DATA:', address);
    
    // Get the authentication token from MSAL
    const msalInstance = (window as any).msal;
    const account = msalInstance?.instance?.getActiveAccount() || 
                  (msalInstance?.instance?.getAllAccounts().length > 0 ? 
                   msalInstance?.instance?.getAllAccounts()[0] : null);
    
    let headers = this.httpOptions.headers;
    
    // If we have an account, try to get the ID token
    if (account && account.idToken) {
      headers = headers.set('Authorization', `Bearer ${account.idToken}`);
    }
    
    return this._http.get(url, { headers: headers }).pipe(
      tap(response => {
        console.log("VALIDATION RESPONSE:", response);
        console.log("Has Error?", response && response['Address'] && response['Address']['Error']);
      })
    );
  }

  public GetStateAndCityForZip(zip: string, country: string = 'US'): any {
    let url = ConfigurationSettings.REST_API_URL + "/api/Address/GetStateAndCity/"+encodeURIComponent(zip)+"/"+encodeURIComponent(country);
    return this._http.get(url).pipe(
      tap(x => console.log("Get city and state for zip code")));
  }


  public async getAddressesByEmail(email: string): Promise<any> {
    let url = ConfigurationSettings.REST_API_URL + "/api/Address/recipients/" + email + "/addresses"
    return await this._http.get(url).pipe(
      tap(x => console.log("Fetched Addresss"))).toPromise();
  }

  public async getAddressesOfAllRecipient(): Promise<any> {
    let url = ConfigurationSettings.REST_API_URL + "/api/Address/recipients/addresses"
    return await this._http.get(url).pipe(
      tap(x => console.log("Fetched Addresss"))).toPromise();
  }

  public updateAddress(address: AddressModel, email: string): any {
    let url = ConfigurationSettings.REST_API_URL + "/api/Address/recipients/" + email + "/addresses"
    let body = JSON.stringify(address);
    return this._http.put(
      url,
      body, this.httpOptions).pipe(
        tap(x => console.log("address updated"))
      );
  }

  public deleteAddress(Id: number): any {
    let url = ConfigurationSettings.REST_API_URL + "/api/addresss/" + Id;
    return this._http.delete(url).pipe(
      tap(x => console.log("Deleted Address")));
  }
}